import { z } from "zod";
import { COVERAGE_GAP_SORTS, COVERAGE_GAP_STATES } from "@shared/types/corpus/api.ts";

/** What the Coverage gaps list shows. It lives in the URL, so a link opens the same view. */
export const coverageGapFiltersSchema = z.object({
  /** Whether the gaps still worked on are shown, or the closed ones. */
  state: z.enum(COVERAGE_GAP_STATES).default("open"),
  /** Only the closed gaps with people still to be told. */
  toTell: z.stringbool().default(false),
  /** What the open gaps are ranked by first. */
  sort: z.enum(COVERAGE_GAP_SORTS).default("askers"),
});

export type CoverageGapFilters = z.output<typeof coverageGapFiltersSchema>;
